export const Text = {
  enum: "enum",
  percent: "percent",
  hidden: "hidden"
};
export default Text;
